// src/components/practice/tasks/writing/parsers/osdB2EssayParser.js
// Parser for OSD B2 Essay format with opinion boxes

export const parseOsdB2EssayContent = (scenario) => {
    if (!scenario) return null;

    const lines = scenario.split('\n').filter(line => line.trim());
    const result = {
        introText: '',
        topic: '',
        statements: [],
        instructions: ''
    };

    let collectingInstructions = false;

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();

        // Extract topic (text in bold with **)
        if (line.includes('**') && !line.startsWith('*') && !collectingInstructions) {
            const topicMatch = line.match(/\*\*[„"](.+?)[""]\*\*/);
            if (topicMatch) {
                result.topic = topicMatch[1];
            }
            // Store intro text (before the bullets)
            if (!result.introText) {
                result.introText = line.replace(/\*\*/g, '');
            }
        }
        // Extract statements - Handle BOTH formats
        else if (line.startsWith('*') && !collectingInstructions) {
            let statementText = '';

            // Format B: * **Bold Header:** *italic text*
            if (line.includes('**') && line.includes(':')) {
                // Extract both header and description
                const headerMatch = line.match(/\*\*(.+?):\*\*/);
                const descMatch = line.match(/:\*\*\s*\*(.+?)\*/);

                if (headerMatch && descMatch) {
                    statementText = `${headerMatch[1]}: ${descMatch[1]}`;
                } else if (headerMatch) {
                    // Just header without description
                    const restOfLine = line.split(':**')[1] || '';
                    statementText = `${headerMatch[1]}: ${restOfLine.replace(/\*/g, '').trim()}`;
                }
            }
            // Format A: * *„quoted text"*
            else if (line.includes('„') || line.includes('"') || line.includes('*')) {
                statementText = line
                    .replace(/^\*\s*/, '')
                    .replace(/\*$/, '')
                    .replace(/[„""]/g, '')
                    .replace(/\*/g, '')
                    .trim();
            }

            if (statementText) {
                result.statements.push(statementText);
            }
        }
        // Extract numbered instructions
        else if (line.match(/^\d+\./)) {
            collectingInstructions = true;
            result.instructions += line + '\n';
        }
        else if (collectingInstructions) {
            result.instructions += line + '\n';
        }
        // Store instruction intro text
        else if (line.includes('Schreiben Sie nun') && !result.instructionIntro) {
            result.instructionIntro = line;
        }
    }

    console.log('Parsed OSD B2 essay content:', result);
    return result;
};